import SettingsManager from "./_settings_manager";

declare global {
    export interface Window {
        ETDR_RD: any;
        ETDR: any;
        SettingsManager: SettingsManager;
        selectedState: any;
        selectedItemId: Object[];
    }

    // There is no typescript binding for the jQuery-csv plugin, so we fake it
    // Interface merging will handle it, just define the $.csv property as "any".
    // This basically disables the type checks
    interface JQueryStatic {
        csv: any;
    }

    interface Boolean {
        toString(): string
    }

    interface MVCxClientGridView {
        cpSearchPanelFilter: string;
    }
}

export namespace Interfaces {

    export interface BaseJsonResponse {
        success: boolean;
        message: string;
        errorText: string | undefined | null;
    }

    export interface ValidationResponse extends BaseJsonResponse {
        isValid: boolean;
    };

    export interface EphatFilterResponse extends BaseJsonResponse {
        error: boolean;
        errorId: string;
    };

    export interface JsonResponseWithResult extends BaseJsonResponse {
        result: any;
    };

    export interface JsonResponseForSignOff extends BaseJsonResponse {
        filingState: string;
        selectedClerkName: string;
    };

    export interface MVCxClientGridViewWithCustomProperties extends MVCxClientGridView {
        cpDownloadDocData: string;
        cpAllKeysOnPage: string;
        cpNeedToWarnUserAboutUnfinishedKshForm: boolean;
    };

    export interface MVCxClientGridViewWithFilterStatusInfo extends MVCxClientGridView {
        cpIsRowFilteringActive: boolean;
        cpIsSearchPanelFilteringActive: boolean;
    };

    export interface MVCxClientGridViewForCheckedRealties extends MVCxClientGridViewWithSelectedKeys {
        cpAllKeys: number[];
    }

    export interface MVCxClientGridViewWithRelatedClientsInfos extends MVCxClientGridViewWithSelectedKeys {
        cpIsSave: boolean;
        cpIsCallbackError: boolean;
        cpHaveToCloseModalWindow: boolean;
        cpErrorGuid: boolean;
        cpErrorText: string;
        cpIsAnyElement: boolean;
        ConvertKeyToVisibleIndex: Function;
    };

    export interface MVCxClientGridViewWithSelectedKeys extends MVCxClientGridView {
        cpSelectedKeys: string[];
        GetVisibleRowsIndicesForAdaptivity: Function;
        cpIsInit: boolean;
        cpUnderRefresh: boolean;
        isCbSelectAllChecked: boolean;
        GetChecked: Function;
    }

    export interface NoticeActions {
        Check: Function;
        Enable: Function;
        Disable: Function;
    }

    export interface NoticeViews {
        ActiveList: string;
        ActiveView: HTMLElement;
        Set: Function;
    }

    export interface MVCxClientGridViewWithCallbackErrorMessage extends MVCxClientGridView {
        cpCallbackErrorString: string;
    };

    export interface MVCxClientGridViewWithScrollToRowIndex extends MVCxClientGridView {
        scrollToRowIndex: number;
        GetRowIndicesVisibleInViewPort: (isPartiallyVisible: boolean) => number[];
    }

    export interface DeleteProcessActionJsonResponse extends BaseJsonResponse {
        subProcessId: number;
        needPageRefresh: boolean;
    }

    export interface DocumentEditorControllerResponse extends JsonResponseWithResult {
        userName: string;
    }

    export interface RedmineFileAttachment {
        Content: string;
        FileName: string;
        MimeType: string;
    }

    export interface JsonResponseWithMultipleErrorSupport extends BaseJsonResponse {
        errorTexts: string[];
    }

    export interface JsonResponseWithAttachment {
        success: boolean;
        message: string;
        content: string;
        fileName: string;
        uploadDate: string;
        estateId: number;
    };

    export interface UserSearchForMainAdminSearchParams {
        userId: number;
        idmId: number;
        userDisplayName: string;
        uniqueId: string;
        email: string;
        officeDisplayName: string;
        isRegisteredToOffice: boolean;
        isSystemAdmin: boolean;
        isOfficeAdmin: boolean;
        isSystemCustomerService: boolean;
        isIntegratedCustomerService: boolean;
        isSystemInspector: boolean;
    }

    export interface Ksh1081Summary {
        BuildingPermitCount: number;
        BuildingPermitBuildingCount: number;
        BuildingPermitFlatCount: number;
        NewBuildingSimpleProcessCount: number;
        NewBuildingSimpleProcessBuildingCount: number;
        NewBuildingSimpleProcessFlatCount: number;
        BuildingExpansionSimpleProcessCount: number;
        BuildingExpansionSimpleProcessBuildingCount: number;
        BuildingExpansionSimpleProcessFlatCount: number;
    }

    export interface KshProcessLevelSummaryRequest {
        year: number;
        month: number;
        areaId: number;
        settlementName?: string;
    }
}

export default Interfaces;
